import styled from "styled-components";

export const ArrowIconWrapper = styled.div`
  display: flex;
  align-items: center;
  margin-right: 0.5rem;
  color: ${(props) => props.theme.colors.LINK_COLOR};
`;

export const BackwardsNavigationWrapper = styled.div`
  margin-bottom: -3rem;
  align-items: center;
  display: flex;
  color: ${(props) => props.theme.colors.LINK_COLOR};
  padding: 1rem;
  transition: 0.4s;
  font-weight: 600;
  cursor: pointer;

  &:hover {
    ${ArrowIconWrapper} {
      transition: 0.2s;
      transform: translate(-0.5rem);
    }
  }
`;
